import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { type User } from '../types';

export interface ImpersonatedUser {
  id: number;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  role: string;
}

interface ImpersonationState {
  isImpersonating: boolean;
  impersonationToken: string | null;
  impersonatedUser: ImpersonatedUser | null;
  originalToken: string | null;
  originalUser: User | null;

  startImpersonation: (
    impersonationToken: string,
    targetUser: ImpersonatedUser,
    originalToken: string,
    originalUser: User
  ) => void;

  endImpersonation: () => void;
}

export const useImpersonationStore = create<ImpersonationState>()(
  persist(
    (set) => ({
      isImpersonating: false,
      impersonationToken: null,
      impersonatedUser: null,
      originalToken: null,
      originalUser: null,

      startImpersonation: (
        impersonationToken: string,
        targetUser: ImpersonatedUser,
        originalToken: string,
        originalUser: User
      ) => {
        localStorage.setItem('token', impersonationToken);
        set({
          isImpersonating: true,
          impersonationToken,
          impersonatedUser: targetUser,
          originalToken,
          originalUser,
        });
      },

      endImpersonation: () => {
        set({
          isImpersonating: false,
          impersonationToken: null,
          impersonatedUser: null,
          originalToken: null,
          originalUser: null,
        });
      },
    }),
    {
      name: 'impersonation-storage',
      partialize: (state) => ({
        isImpersonating: state.isImpersonating,
        impersonationToken: state.impersonationToken,
        impersonatedUser: state.impersonatedUser,
        originalToken: state.originalToken,
        originalUser: state.originalUser,
      }),
    }
  )
);
